import { z } from 'zod';

export const MetalLevel = z.string().nullable();

export type MetalLevel = z.infer<typeof MetalLevel>;
